import React from 'react';
import loadingGif from '../../Public/ImageFolder/Loading.gif'; // adjust path if needed

const Loading = () => {
    return (
        <div style={styles.container}>
            <img src={loadingGif} alt="Loading..." style={styles.image} />
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100%',
    },
    image: {
        width: '120px', // adjust size if needed
        height: '120px',
    },
};

export default Loading;